import { DeviceType } from "@sparkware/uc-sdk-core";
import { RootState } from "../../store";

export const isScrollableDevice = ({ configuration }: RootState) => {
  const { deviceType } = configuration.deviceInfo;

  return deviceType === DeviceType.Unknown || deviceType === DeviceType.PC; // true for 0, 3
};
